import * as React from 'react';

export interface ContextualHelpContextData {
  entityId?: string;
}

interface ContextualHelpState {
  helpId: string | null;
  data: ContextualHelpContextData | null;
}

interface IContextualHelpContext {
  contextualHelpId: string | null;
  contextData: ContextualHelpContextData | null;
  setContextualHelp: (
    nextContextualHelpId: string | null,
    contextData?: ContextualHelpContextData
  ) => void;
}

export const ContextualHelpContext =
  React.createContext<IContextualHelpContext | null>(null);

export const ContextualHelpProvider = ({
  children,
}: React.PropsWithChildren<Record<string, unknown>>) => {
  const [state, setState] = React.useState<ContextualHelpState>({
    helpId: null,
    data: null,
  });

  const setContextualHelp = React.useCallback(
    (
      nextContextualHelpId: string | null,
      nextContextData?: ContextualHelpContextData
    ) => {
      setState({
        helpId: nextContextualHelpId,
        data: nextContextData ?? null,
      });
    },
    []
  );

  return (
    <ContextualHelpContext.Provider
      value={{
        contextualHelpId: state.helpId,
        contextData: state.data,
        setContextualHelp,
      }}
    >
      {children}
    </ContextualHelpContext.Provider>
  );
};
